import Grid from "components/primitives/Grid";
import InfoCard from "components/InfoCard";
import InfoCardControlDescriptor from "components/InfoCard/InfoCardControlDescriptor";
import Tables from "components/Tables";
import GroupIcon from "components/Icons/GroupsIcon";
import Mui5 from "components/mui5";
import { useTranslation } from "react-i18next";
import NotePadIcon from "components/IconsStandardized/NotePadIcon/NotePadIcon";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { linkGroups } from "config/knowledgebase-links";

export interface GroupsInfoCardProps {
  onClose(): void;
}

function GroupsInfoCard(props: GroupsInfoCardProps) {
  const { t } = useTranslation();

  return (
    <InfoCard title={t("group.all.info_card_header_text")} icon={<GroupIcon />} onClose={props.onClose}>
      <Grid container>
        <Grid size={12} pb={0}>
          <Typography gutterBottom variant="h4">
            {t("group.all.info_card_description1")} {t("group.all.info_card_description2")}
          </Typography>
        </Grid>
        <Grid size={12} textAlign="center" p={2}>
          <Mui5.Button
            fullWidth={false}
            sx={{ width: 320 }}
            size="medium"
            color="primary"
            LinkComponent="a"
            // @ts-ignore
            rel="noopener noreferrer"
            // @ts-ignore
            target="_blank"
            href={linkGroups}
          >
            {t("global.more_info_button_text")}
          </Mui5.Button>
        </Grid>
        <Grid size={12}>
          <Divider sx={{ my: 1 }} />
        </Grid>
        <Grid size={12}>
          <InfoCardControlDescriptor
            title={t("group.all.info_card_title1")}
            control={
              <>
                <Mui5.Button size="small" sx={{ pointerEvents: "none" }}>
                  {t("group.all.info_card_add_button_text")}
                </Mui5.Button>
              </>
            }
            label={t("group.all.info_card_label1")}
          />
        </Grid>
        <Grid size={12} pb={0.5}>
          <InfoCardControlDescriptor
            title={t("group.all.info_card_title2")}
            control={<NotePadIcon fontSize="small" />}
            label={t("group.all.info_card_label2")}
          />
        </Grid>
        <Grid size={12}>
          <InfoCardControlDescriptor
            title={t("group.all.info_card_title3")}
            control={<Tables.Icons.Delete />}
            label={t("group.all.info_card_label3")}
          />
        </Grid>
      </Grid>
    </InfoCard>
  );
}

export default GroupsInfoCard;
